module.exports = __webpack_public_path__ + "img/08_Roof to Wall Rod.a7d6731d.png";